<tilby-active-sale-header-info
    [disableActions]="!!isPaymentsState"
    [showSaleFinalAmount]="true"
    [sale]="sale"
    [documentData]="documentData"
    [accessibility]="isAccessibility"
    [deselectSalesFromMenuBar]="deselectSalesFromMenuBar"
    [isHidePrices]="!showPrices"
    [isTableNameOnTopBar]="isTableNameOnTopBar"
    [isOrderPrinterPermitted]="isOrderPrinterPermitted"
    [isPaymentsState]="!!isPaymentsState"
    [contextMenu]="contextMenu"
    (addCustomerActionEvent)="addCustomerAction()"
    (removeCustomerActionEvent)="removeCustomerAction()"
    (selectSaleActionEvent)="selectSaleAction()"
    (preBillActionEvent)="printNonFiscalSale()"
    (saleChangeNameActionEvent)="saleChangeName()"
    (deselectSaleActionEvent)="deselectSaleAction()"
    (openOrderPrinterSelectActionEvent)="printNonFiscalSale(true)"
/>
